<template>
    <b-container fluid class="landing">
        <b-row>
            <b-col class="col-10 mx-auto py-5 my-5">
              <h5 class="section-title mb-5">Política de Cookies</h5>
              <div class="policy-document">
                <p class="update-date"><strong>Última actualización:</strong> Diciembre 2025</p>
                
                <section class="policy-section">
                  <h3>1. ¿QUÉ SON LAS COOKIES?</h3>
                  <p>
                    Las cookies son pequeños archivos de texto que se almacenan en tu dispositivo (ordenador, tablet o móvil) 
                    cuando visitas nuestra página web o utilizas nuestra aplicación. Las cookies permiten que el sitio web 
                    reconozca tu dispositivo y almacene cierta información sobre tus preferencias o acciones pasadas.
                  </p>
                  <p>
                    Las cookies son muy útiles y tienen múltiples funciones que mejoran tu experiencia de navegación, 
                    como recordar tus preferencias, analizar cómo interactúas con nuestros servicios y personalizar 
                    el contenido que te mostramos.
                  </p>
                </section>

                <section class="policy-section">
                  <h3>2. ¿CÓMO UTILIZA GOX LAS COOKIES?</h3>
                  <p>
                    En GOX utilizamos cookies y tecnologías similares para mejorar tu experiencia, entender cómo 
                    utilizas nuestros servicios, y ofrecerte contenido personalizado. Las cookies nos ayudan a:
                  </p>
                  <ul>
                    <li>Mantener tu sesión activa mientras navegas</li>
                    <li>Recordar tus preferencias y configuraciones</li>
                    <li>Mejorar la seguridad de tu cuenta</li>
                    <li>Analizar el rendimiento de nuestra plataforma</li>
                    <li>Personalizar el contenido y las ofertas que recibes</li>
                    <li>Medir la efectividad de nuestras campañas publicitarias</li>
                  </ul>
                </section>

                <section class="policy-section">
                  <h3>3. TIPOS DE COOKIES QUE UTILIZAMOS</h3>
                  
                  <h4>3.1 Cookies Estrictamente Necesarias</h4>
                  <p>
                    Estas cookies son esenciales para que puedas navegar por nuestra plataforma y utilizar sus funciones. 
                    Sin estas cookies, no podríamos proporcionar ciertos servicios básicos.
                  </p>
                  <p><strong>Ejemplos:</strong></p>
                  <ul>
                    <li>Cookies de autenticación para mantener tu sesión iniciada</li>
                    <li>Cookies de seguridad para proteger tu cuenta</li>
                    <li>Cookies de balance de carga para distribuir el tráfico</li>
                  </ul>
                  <p class="note"><em>Estas cookies no se pueden desactivar ya que son necesarias para el funcionamiento del servicio.</em></p>

                  <h4>3.2 Cookies de Rendimiento y Analíticas</h4>
                  <p>
                    Estas cookies nos ayudan a entender cómo los usuarios interactúan con nuestra plataforma, 
                    recopilando información de forma anónima sobre las páginas visitadas, el tiempo de permanencia, 
                    y los errores que puedan surgir.
                  </p>
                  <p><strong>Ejemplos:</strong></p>
                  <ul>
                    <li>Google Analytics para analizar el tráfico web</li>
                    <li>Cookies de seguimiento de errores y rendimiento</li>
                    <li>Métricas de uso de la aplicación</li>
                  </ul>

                  <h4>3.3 Cookies de Funcionalidad</h4>
                  <p>
                    Estas cookies permiten recordar tus preferencias y personalizar tu experiencia en la plataforma.
                  </p>
                  <p><strong>Ejemplos:</strong></p>
                  <ul>
                    <li>Preferencias de idioma</li>
                    <li>Configuración de notificaciones</li>
                    <li>Historial de navegación en establecimientos</li>
                    <li>Favoritos y listas guardadas</li>
                  </ul>

                  <h4>3.4 Cookies de Publicidad y Marketing</h4>
                  <p>
                    Estas cookies se utilizan para mostrarte contenido publicitario relevante y medir la efectividad 
                    de nuestras campañas. También nos ayudan a limitar el número de veces que ves un anuncio.
                  </p>
                  <p><strong>Ejemplos:</strong></p>
                  <ul>
                    <li>Cookies de redes sociales (Facebook, Instagram)</li>
                    <li>Cookies de remarketing</li>
                    <li>Seguimiento de conversiones</li>
                    <li>Personalización de ofertas y promociones</li>
                  </ul>
                </section>

                <section class="policy-section">
                  <h3>4. COOKIES DE TERCEROS</h3>
                  <p>
                    Además de nuestras propias cookies, utilizamos cookies de terceros para diversos propósitos:
                  </p>
                  
                  <h4>4.1 Servicios de Análisis</h4>
                  <ul>
                    <li><strong>Google Analytics:</strong> Para analizar el uso de nuestra plataforma</li>
                    <li><strong>Firebase:</strong> Para análisis de aplicaciones móviles</li>
                  </ul>

                  <h4>4.2 Redes Sociales</h4>
                  <ul>
                    <li><strong>Facebook Pixel:</strong> Para medir campañas publicitarias</li>
                    <li><strong>Instagram:</strong> Para integración de contenido social</li>
                  </ul>

                  <h4>4.3 Servicios de Pago</h4>
                  <ul>
                    <li>Cookies de proveedores de servicios de pago para procesar transacciones de forma segura</li>
                  </ul>

                  <p class="note">
                    <em>Nota: Estos terceros tienen sus propias políticas de privacidad y cookies. 
                    Te recomendamos revisarlas para entender cómo gestionan tu información.</em>
                  </p>
                </section>

                <section class="policy-section">
                  <h3>5. DURACIÓN DE LAS COOKIES</h3>
                  
                  <h4>5.1 Cookies de Sesión</h4>
                  <p>
                    Son cookies temporales que permanecen en tu dispositivo hasta que cierras el navegador o la aplicación. 
                    Se utilizan principalmente para mantener tu sesión activa.
                  </p>

                  <h4>5.2 Cookies Persistentes</h4>
                  <p>
                    Estas cookies permanecen en tu dispositivo durante un período de tiempo determinado o hasta que 
                    las elimines manualmente. Se utilizan para recordar tus preferencias entre sesiones.
                  </p>
                  <p>Nuestras cookies persistentes tienen las siguientes duraciones:</p>
                  <ul>
                    <li><strong>Autenticación:</strong> Hasta 30 días</li>
                    <li><strong>Preferencias:</strong> Hasta 1 año</li>
                    <li><strong>Análisis:</strong> Hasta 2 años</li>
                    <li><strong>Marketing:</strong> Hasta 90 días</li>
                  </ul>
                </section>

                <section class="policy-section">
                  <h3>6. ¿CÓMO GESTIONAR O ELIMINAR COOKIES?</h3>
                  
                  <h4>6.1 Configuración del Navegador</h4>
                  <p>
                    La mayoría de los navegadores web permiten gestionar las cookies a través de su configuración. 
                    Puedes configurar tu navegador para:
                  </p>
                  <ul>
                    <li>Bloquear todas las cookies</li>
                    <li>Aceptar solo cookies de sitios específicos</li>
                    <li>Eliminar cookies al cerrar el navegador</li>
                    <li>Recibir notificaciones cuando se instalen cookies</li>
                  </ul>

                  <h4>6.2 Enlaces de Ayuda por Navegador</h4>
                  <ul>
                    <li><strong>Google Chrome:</strong> <a href="https://support.google.com/chrome/answer/95647" target="_blank">Gestionar cookies en Chrome</a></li>
                    <li><strong>Mozilla Firefox:</strong> <a href="https://support.mozilla.org/es/kb/cookies-informacion-que-los-sitios-web-guardan-en-" target="_blank">Gestionar cookies en Firefox</a></li>
                    <li><strong>Safari:</strong> <a href="https://support.apple.com/es-es/guide/safari/sfri11471/mac" target="_blank">Gestionar cookies en Safari</a></li>
                    <li><strong>Microsoft Edge:</strong> <a href="https://support.microsoft.com/es-es/windows/eliminar-y-administrar-cookies" target="_blank">Gestionar cookies en Edge</a></li>
                  </ul>

                  <h4>6.3 Aplicación Móvil</h4>
                  <p>
                    En la aplicación móvil GOX, puedes gestionar tus preferencias de cookies desde:
                  </p>
                  <p><strong>Menú → Configuración → Privacidad → Gestión de Cookies</strong></p>

                  <p class="note warning">
                    <em><strong>⚠️ Importante:</strong> Si desactivas o eliminas cookies, algunas funcionalidades 
                    de la plataforma pueden no funcionar correctamente. Por ejemplo, es posible que necesites 
                    iniciar sesión cada vez que visites la aplicación.</em>
                  </p>
                </section>

                <section class="policy-section">
                  <h3>7. COOKIES Y DISPOSITIVOS MÓVILES</h3>
                  <p>
                    En dispositivos móviles, además de cookies, utilizamos identificadores publicitarios:
                  </p>
                  <ul>
                    <li><strong>iOS:</strong> IDFA (Identifier for Advertisers)</li>
                    <li><strong>Android:</strong> AAID (Android Advertising ID)</li>
                  </ul>
                  <p>Puedes gestionar estos identificadores desde:</p>
                  <ul>
                    <li><strong>iOS:</strong> Ajustes → Privacidad → Publicidad → Limitar seguimiento de anuncios</li>
                    <li><strong>Android:</strong> Ajustes → Google → Anuncios → Restablecer ID de publicidad / Inhabilitar anuncios personalizados</li>
                  </ul>
                </section>

                <section class="policy-section">
                  <h3>8. ACTUALIZACIONES DE ESTA POLÍTICA</h3>
                  <p>
                    Podemos actualizar esta Política de Cookies periódicamente para reflejar cambios en nuestras 
                    prácticas o por razones operativas, legales o regulatorias. Te notificaremos sobre cambios 
                    significativos a través de la aplicación o por correo electrónico.
                  </p>
                  <p>
                    La fecha de la última actualización se encuentra al inicio de este documento.
                  </p>
                </section>

                <section class="policy-section">
                  <h3>9. TUS DERECHOS</h3>
                  <p>
                    De acuerdo con la Ley de Protección de Datos Personales del Perú, tienes derecho a:
                  </p>
                  <ul>
                    <li>Conocer qué cookies utilizamos y para qué</li>
                    <li>Aceptar o rechazar cookies no esenciales</li>
                    <li>Modificar tus preferencias de cookies en cualquier momento</li>
                    <li>Solicitar información sobre el tratamiento de tus datos</li>
                    <li>Revocar tu consentimiento para el uso de cookies</li>
                  </ul>
                </section>

                <section class="policy-section">
                  <h3>10. MÁS INFORMACIÓN Y CONTACTO</h3>
                  <p>
                    Si tienes preguntas sobre nuestra Política de Cookies o deseas ejercer tus derechos, 
                    puedes contactarnos:
                  </p>
                  <ul>
                    <li><strong>Correo electrónico:</strong> <a href="mailto:atencionalcliente@puntosgox.com">atencionalcliente@puntosgox.com</a></li>
                    <li><strong>Sitio web:</strong> <a href="https://puntosgox.com" target="_blank">www.puntosgox.com</a></li>
                  </ul>
                  <p>
                    Para más información sobre cómo tratamos tus datos personales, consulta nuestra 
                    <router-link to="/privacidad">Política de Privacidad</router-link>.
                  </p>
                </section>
              </div>
            </b-col>
        </b-row>
    </b-container>
</template>

<script>
import EventBus from '@/bus/index'

export default {
    name: 'Cookies',
    components: {},
    data: () => ({
        show: true
    }),
    created: function () {
        EventBus.$on('show-panel', (show) => {
            this.show = show
        });
    },
    methods: {}
}
</script>

<style scoped>
.policy-document {
  font-family: 'Raleway', sans-serif;
  line-height: 1.8;
  color: #333;
}

.update-date {
  font-size: 0.9rem;
  color: #666;
  margin-bottom: 2rem;
  font-style: italic;
}

.policy-section {
  margin-bottom: 2.5rem;
}

.policy-section h3 {
  color: #2c3e50;
  font-size: 1.4rem;
  font-weight: 700;
  margin-bottom: 1rem;
  border-bottom: 2px solid #e74c3c;
  padding-bottom: 0.5rem;
}

.policy-section h4 {
  color: #34495e;
  font-size: 1.1rem;
  font-weight: 600;
  margin-top: 1.5rem;
  margin-bottom: 0.8rem;
}

.policy-section p {
  margin-bottom: 1rem;
  text-align: justify;
}

.policy-section ul {
  margin-left: 1.5rem;
  margin-bottom: 1rem;
}

.policy-section ul li {
  margin-bottom: 0.5rem;
}

.policy-section a {
  color: #e74c3c;
  text-decoration: none;
  font-weight: 600;
}

.policy-section a:hover {
  text-decoration: underline;
}

.note {
  background-color: #f8f9fa;
  border-left: 4px solid #17a2b8;
  padding: 1rem;
  margin: 1rem 0;
  border-radius: 4px;
}

.note.warning {
  background-color: #fff3cd;
  border-left-color: #ffc107;
}

.note em {
  color: #555;
}

@media (max-width: 768px) {
  .policy-section h3 {
    font-size: 1.2rem;
  }
  
  .policy-section h4 {
    font-size: 1rem;
  }
  
  .policy-document {
    font-size: 0.95rem;
  }
}
</style>


